import LinkArrow from "@/assets/svgs/LinkArrow";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { MouseEvent, ReactNode, useMemo, useState } from "react";

export enum ButtonTypeEnum {
  Primary = "Primary",
  Secondary = "Secondary",
  Link = "Link",
  Gradient = "Gradient",
  GradientBlue = "GradientBlue",
}

export enum ButtonSizeEnum {
  Regular = "Regular",
  Small = "Small",
}

export enum ButtonAsEnum {
  button = "button",
  Link = "Link",
}
type CTAType = {
  text?: string;
};

type ButtonPropsType = {
  type?: ButtonTypeEnum;
  size?: ButtonSizeEnum;
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  href?: string;
  target?: string;
  cta?: CTAType;
  clickId?: string;
};

const Button = (props: ButtonPropsType) => {
  const { type = ButtonTypeEnum.Primary, size = ButtonSizeEnum.Regular, cta } =
    props;

  const [isHover, setHover] = useState(false);
  const router = useRouter();
  const url = router.query.page;
  const isOnlineCoursePlatform = url === "online-course-platform";
  const isWebinarRebeccaSchocker = url === "webinar-rebecca-schocker";

  

  const className = useMemo(
    () =>
      classNames(
        "transition ease-in-out inline-flex justify-center items-center",
        {
          "bg-gradient-to-r from-[#4E5DE0] from-10% to-[#5868F7] to-100% gap-2 px-4 py-2.5 rounded-[41px] text-white":
            type === ButtonTypeEnum.Primary,
          "bg-white border border-[#E5E5E5] gap-1 px-4 py-2.5 rounded-[41px] text-[#3A3D50]":
            type === ButtonTypeEnum.Secondary,
          "active:bg-grey-1 gap-1": type === ButtonTypeEnum.Link,
          "text-grey-0 bg-green-gradient hover:bg-green-gradient-hover active:bg-green-gradient-pressed rounded-[41px]":
            type === ButtonTypeEnum.Gradient,
          "text-grey-0 bg-blue-gradient hover:bg-blue-gradient-hover active:bg-blue-gradient-pressed rounded-[41px]":
            type === ButtonTypeEnum.GradientBlue,
        },
        {
          "px-4 py-2.5 text-title-14": size === ButtonSizeEnum.Regular,
          "px-3 py-2.5 text-title-12": size === ButtonSizeEnum.Small,
        }
      ),
    [size, type]
  );

  const handleMouseOver = () => {
    setHover(true);
  };
  const handleMosueLeave = () => {
    setHover(false);
  };

  if (props.href) {
    return (
      <Link
        href={props.href}
        target={props.target}
        onClick={(e) => {
          if (props.onClick) props.onClick(e);
        }}
        className={className}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMosueLeave}
        id={props.clickId}
      >
        {props.children}
        {type === ButtonTypeEnum.Link && <LinkArrow isHover={isHover} />}
      </Link>
    );
  } else {
    return (
      <button 
        onClick={(e) => {
          if (props.onClick) props.onClick(e);
        }} 
        className={className} 
        id={props.clickId}
      >
        {props.children}
        {type === ButtonTypeEnum.Link && <LinkArrow isHover={isHover} />}
      </button>
    );
  }
};

export default Button;
